import {
  PermissionValues,
  useCurrentAccount,
  useIsInImpersonateUser
} from '@gripp/shared-logic';
import {
  AdminImpersonateUser,
  KeyboardSafeView,
  Layout,
  ProfileForm,
  SaveFormBottomOld as SaveForm,
  Spacing,
  useProfileForm,
} from '@gripp/shared-ui';
import { MediaPicker } from 'apps/gripp-web/src/shared/components/media/mediaPicker';
import { getMediaBaseUrl } from 'apps/gripp-web/src/shared/mediaUtils';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';

export const Profile = () => {
  const mediaUrl = getMediaBaseUrl();
  const { t } = useTranslation();
  const { account } = useCurrentAccount();
  const isInImpersonateUser = useIsInImpersonateUser();
  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useProfileForm();

  const isGlobalAdmin = useCallback(() => {
    return account && account.hasPermission(PermissionValues.globalAdmin);
  }, [account]);

  return (
    <KeyboardSafeView style={styles.container}>
      <ScrollView
        contentContainerStyle={styles.contentContainer}
        scrollEnabled={true}
        showsVerticalScrollIndicator={true}
      >
        <SaveForm
          title={t('avatar.menu.profile')}
          onSubmit={handleSubmit}
          isDirty={isDirty}
          isValid={isValid}
          hasBorder={true}
        >
          <ProfileForm
            control={control}
            mediaUrl={mediaUrl}
            imagePicker={MediaPicker}
            inputMaxWidth={322}
          />
        </SaveForm>
        {(isGlobalAdmin() || !!isInImpersonateUser) && (
          <View style={styles.workspacePicker}>
            <AdminImpersonateUser />
          </View>
        )}
      </ScrollView>
    </KeyboardSafeView>
  );
};

const styles = StyleSheet.create({
  container: {
    ...Layout.container,
  },
  contentContainer: {
    paddingVertical: Spacing.basePadding.paddingVertical,
  },
  workspacePicker: {
    marginTop: 16,
  },
});
